<template>
  <div class="smsPlatform">
    <!--数据部分-->
    <div class="centerStructure">
      <!--检索条件-->
      <div class="searchBox">
        <span class="inp">客户名称：</span>

        <el-select v-model="searchForm.cusId" placeholder="客户名称">
          <el-option class="wh140" :value="0" label="全部">全部</el-option>
          <el-option
              class="wh140"
              v-for="item in searchForm.cusList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <span class="inp">短信平台：</span>
        <el-select v-model="searchForm.platformId" placeholder="短信平台">
          <el-option class="wh140" :value="0" label="全部">全部</el-option>
          <el-option
              class="wh140"
              v-for="item in searchForm.platformList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="search()" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="insert()" v-show="$root.$permissionMap.has('SaveCustomer')"
                   icon="el-icon-circle-plus-outline">添加
        </el-button>
      </div>
      <!--表格数据-->
      <el-table
          :data="tableData"
          border
          ref="singleTable"
          style="width: 100%"
          height="calc(100% - 84px)">
        <el-table-column
            fixed
            header-align="center"
            align="center"
            type="index"
            width="50">
        </el-table-column>
        <el-table-column
            prop="operation"
            label="操作"
            width="120px"
            align="center"
            header-align="center">
          <template slot-scope="scope">
            <!--            v-show="$root.$permissionMap.has('UpdateCustomer')"-->
            <span class="tableicon"><i
                @click="update(scope)" class="el-icon-edit"
            ></i></span>
            <!--             v-show="$root.$permissionMap.has('DeleteCustomer')"-->
            <span class="tableicon"><i
                @click="del(scope)" class="el-icon-delete"
            ></i></span>
          </template>
        </el-table-column>
        <template v-for="item in tableTitle">
          <el-table-column
              :align="item.align"
              :header-align="item.halign"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sortable"
              :formatter="item.formatter"
              v-if="item.prop !== 'expireDate'"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column v-if="item.prop === 'expireDate'"
                           :width="item.width"
                           :key="item.prop"
                           :label="item.label"
                           :prop="item.prop"
                           :sortable="item.sortable"
                           :align="item.align"
                           :header-align="item.halign"
          >
            <template slot-scope="scope">
              <span v-html="formatHtml(scope.row.expireDate)"></span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <!--分页数据-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNumber"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
      </el-pagination>
      <!--客户信息弹窗-->
      <el-dialog
          :title="title"
          :visible.sync="opendiaFlag"
          :close-on-click-modal="false"
          :modal-append-to-body="false"
          :before-close="closeDialog"
          width="1020px"
      >
        <!--弹窗左侧信息区域-->
        <div class="formbox">
          <el-form
              :model="entity"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
          >
            <div class="inline" style="display:flex">
              <el-form-item prop="cusId" label="客户名称:">
                <el-select v-model="entity.cusId"
                           placeholder="请选择"
                           class="wh200" :disabled="isMod">
                  <el-option
                      class="wh200"
                      v-for="item in detailCusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="!item.isEnable">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="typeId" label="短信平台:">
                <el-select v-model="entity.typeId"
                           placeholder="请选择"
                           class="wh200" @change="signIsReq" :disabled="isMod">
                  <el-option
                      class="wh200"
                      v-for="item in searchForm.platformList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="monthLimit" label="每月上限:">
                <el-input class="wh200" v-model.trim="entity.monthLimit"
                          placeholder="请输入每月上限" @blur="checkLimit"></el-input>
              </el-form-item>
            </div>
            <div class="inline" style="display:flex">
              <el-form-item prop="smsSignature" label="短信签名:">
                <el-input class="wh200" v-model.trim="entity.smsSignature"
                          placeholder="请输入短信签名"></el-input>
              </el-form-item>
              <el-form-item prop="serviceUrl" label="服务地址:">
                <el-input style="width: 530px" v-model.trim="entity.serviceUrl"
                          placeholder="请输入服务地址"></el-input>
              </el-form-item>
            </div>
            <div class="inline" style="display:flex">
              <el-form-item prop="accessKey" label="授权账号:">
                <el-input class="wh200" v-model.trim="entity.accessKey"
                          placeholder="请输入授权账号"></el-input>
              </el-form-item>
              <el-form-item prop="accessSecret" label="授权密码:">
                <el-input class="wh200" v-model.trim="entity.accessSecret"
                          placeholder="请输入授权密码"></el-input>
              </el-form-item>
              <el-form-item prop="isEnable" label="启用:">
                <el-radio-group class="wh200" v-model="entity.isEnable">
                  <el-radio border :label="true">是</el-radio>
                  <el-radio border :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="inline" style="display:flex">
              <el-form-item prop="remark" label="备注:">
                <el-input style="width: 860px" v-model.trim="entity.remark"
                          placeholder="请输入备注"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--弹窗脚部分-->
        <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm()">取 消</el-button>
                <el-button type="primary" @click="submitForm()">提 交</el-button>
           </span>
      </el-dialog>
    </div>
  </div>
</template>
<!--js部分-->
<script>
import {Mixins} from '@/config/mixins/mixins'
import SearchDialog from '@/components/custom/Searchdialog'
import {IsInteger} from "@/config/validate/common";
import {$http, $httpForList} from "@/config/api/axios";

export default {
  name: 'smsPlatform',   // 修饰的是这个页面
  mixins: [Mixins],  //混入公共方法,慎用.
  components: {
    SearchDialog,  //引入高级查询弹窗
  },
  data() {
    //判断是否为数字
    let isNumber = (rule, value, callback) => {
      if (!IsInteger(value) && value !== '') {
        callback(new Error('请输入整数数字值'));
      } else {
        callback();
      }
    };
    //是否启用转化
    let isEnableFormat = (row, column, cellValue, index) => {
      if (1 == cellValue) {
        cellValue = '是';
      } else {
        cellValue = '否';
      }
      return cellValue;
    };
    return {
      isMod: false,
      //列表表头
      tableTitle: [
        {prop: "cName", label: '客户名称', width: '', align: 'left', halign: 'center', show: true,},
        {prop: "pName", label: '短信平台', width: '', align: 'left', halign: 'center', show: true},
        {
          prop: "monthLimit",
          label: '每月上限',
          width: '150',
          align: 'center',
          halign: 'center',
          show: true,
          sortable: true
        },
        {
          prop: "cou",
          label: '已发送',
          width: '150',
          align: 'center',
          halign: 'center',
          sortable: true,
          show: true
        },
        {
          prop: "serviceUrl",
          label: '调用地址',
          width: '460',
          align: 'center',
          halign: 'center',
          show: true,
        },
        {
          prop: "isEnable",
          label: '启用',
          width: '70',
          align: 'center',
          halign: "center",
          show: true,
          'formatter': isEnableFormat
        },
        {
          prop: "currentTime",
          label: '创建时间',
          width: '160',
          align: 'center',
          halign: 'center',
          show: true,
          sortable: true
        },
      ],
      tableData: [],  //列表数据
      rules: { //弹窗验证规则
        cusId: [{required: true, message: '客户名称不能为空', trigger: 'change'}],
        typeId: [{required: true, message: '短信平台不能为空', trigger: 'change'}],
        serviceUrl: [{required: true, message: '服务地址不能为空', trigger: 'blur'}, {
          max: 100,
          message: "长度不超过100个汉字或字符",
          trigger: "blur"
        }],
        accessKey: [{required: true, message: '授权账号不能为空', trigger: 'blur'}, {
          max: 30,
          message: "长度不超过30个汉字或字符",
          trigger: "blur"
        }],
        accessSecret: [{required: true, message: '授权密码不能为空', trigger: 'blur'}, {
          max: 30,
          message: "长度不超过30个汉字或字符",
          trigger: "blur"
        }],
        smsSignature: [{required: true, message: '短信签名不能为空', trigger: 'blur'}, {
          max: 10,
          message: "长度不超过10个汉字或字符",
          trigger: "blur"
        }],
        monthLimit: [
          {required: true, message: '每月上限不能为空', trigger: 'blur'},
          {pattern: /^[0-9]+$/, message: "只允许输入1-99999的整数", trigger: 'blur'},
          {pattern: /^\+?[1-9]\d{0,4}(\.\d*)?$/, message: "只允许输入1-99999的整数", trigger: "blur"}
        ],
        remark: [{required: false, max: 100, message: '长度不超过100个汉字或字符', trigger: 'blur'}],
      },
      searchForm: {  //检索条件
        cusList: [],
        platformList: [],
        cusId: 0,
        platformId: 0
      },
      detailCusList: [],
      sended: '',
      entity: {
        cusId: '',
        typeId: '',
        serviceUrl: '',
        accessKey: '',
        accessSecret: '',
        smsSignature: '',
        monthLimit: '5000',
        isEnable: true,
        cusName: '',
        remark: '',
        modeId: '',
        pId:''
      },

      //分页数据设置
      pageSize: 20, //条数
      pageNumber: 1,
      pageTotal: 0, //总页数

      // 弹窗表单字段
      title: '短信平台',  //弹窗标题
      opendiaFlag: false, //是否打开弹窗标志
    }
  },
  //监听部分
  watch: {},
  methods: {
    closeDialog(done) {
      this.resetForm()
      done();
    },
    resetForm() {
      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.resetFields();
      this.opendiaFlag = false;
      this.search();
      this.dropDownForCus();
    },
    insert() {
      this.isMod = false,
          this.detailDropDownForCus() ,
          this.opendiaFlag = true
      this.entity.cusId = ''
      this.entity.typeId = ''
      this.entity.serviceUrl = ''
      this.entity.accessKey = ''
      this.entity.accessSecret = ''
      this.entity.smsSignature = ''
      this.entity.monthLimit = '5000'
      this.entity.isEnable = true
      this.entity.cusName = ''
      this.entity.remark = ''
    },
    update(scope) {
      this.opendiaFlag = true
      this.isMod = true
      this.detailDropDownForCus();
      var param = {
        infoId: scope.row.pId
      }
      $http("get", "mobile/sms/info/smsPlatfromInfo", param).then(res => {
        if (res.status === 'SUCCESS') {
          this.entity.cusId = res.data.cusId
          this.entity.typeId = res.data.typeId
          this.entity.serviceUrl = res.data.serviceUrl
          this.entity.accessKey = res.data.accessKey
          this.entity.accessSecret = res.data.accessSecret
          this.entity.smsSignature = res.data.smsSignature
          this.entity.monthLimit = res.data.monthLimit
          this.entity.isEnable = res.data.isEnable
          this.entity.cusName = res.data.cusName
          this.entity.remark = res.data.remark
          this.entity.modeId = res.data.modeId
          this.entity.pId = res.data.pId
          this.sended = res.data.sended
          //短信签名：文本，长度不超过10个汉字或字符，根据短信平台调用方式判断是否必填，如果调用方式为传参时默认必填，否则非必填。
          this.signIsReq();
        }
      })
    },
    del(scope) {
      this.$confirm('删除后当前客户将无法发送手机短信，确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          infoId: scope.row.pId
        }
        $http("post", "mobile/sms/info/delPlatformInfo", param).then(res => {
          if (res.status == 'SUCCESS') {
            this.$message({
              type: 'success',
              message: res.message
            });
            if (this.tableData.length == 1 && this.pageNumber > 1) {
              this.pageNumber = this.pageNumber - 1;
            }
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        });
      })
    },
    submitForm() {
      let param = {
        cusId: this.entity.cusId,
        typeId: this.entity.typeId,
        serviceUrl: this.entity.serviceUrl,
        accessKey: this.entity.accessKey,
        accessSecret: this.entity.accessSecret,
        smsSignature: this.entity.smsSignature,
        monthLimit: this.entity.monthLimit,
        isEnable: this.entity.isEnable,
        userId: this.entity.userId,
        pId: this.entity.pId
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.isMod) {
            $httpForList("post", "mobile/sms/info/updatePlatform", param).then(res => {
              if (res.status === 'SUCCESS') {
                this.msgsuccess(res.message)
                this.resetForm()
              } else {
                this.msgerror(res.message)
              }
            })
          } else {
            $httpForList("post", "mobile/sms/info/insertPlatform", param).then(res => {
              if (res.status === 'SUCCESS') {
                this.msgsuccess(res.message)
                this. resetForm()
              } else {
                this.msgerror(res.message)
              }
            })
          }

        } else {
          this.submitFormLoading = false
          setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          }, 100);
          this.submitFormLoading = false
          return false;
        }
      })
    },
    signIsReq() {
      let length = this.searchForm.platformList.length;
      for (let i = 0; i < length; i++) {
        let lengthKey = this.searchForm.platformList[i];
        if (lengthKey.id == this.entity.typeId) {
          if (lengthKey.modeId == 1) {
            this.rules.smsSignature[0].required = true
            break;
          } else {
            this.rules.smsSignature[0].required = false
            break;
          }
        }
      }
    },
    checkLimit() {
      if (parseInt(this.sended) > parseInt(this.entity.monthLimit)) {
        this.msgerror("每月上限不能小于当月已发数量。")
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.page();
    },
    dropDownForCus() {
      $http("get", "mobile/sms/info/dropDownForCus").then(res => {
        if (res.status === 'SUCCESS') {
          this.searchForm.cusList = res.data;
        }
      })
    },
    detailDropDownForCus() {
      $http("get", "mobile/sms/info/detailDropDownForCus").then(res => {
        if (res.status === 'SUCCESS') {
          this.detailCusList = res.data;
        }
      })
    },
    dropDownForPlatfrom() {
      $http("get", "mobile/sms/info/dropDownForPlatform").then(res => {
        if (res.status === 'SUCCESS') {
          this.searchForm.platformList = res.data;
        }
      })
    },
    search() {
      this.handleCurrentChange(1)
    },
    page() {
      this.selfLoadingOpen('.smsPlatform');
      var param = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        cusId: this.searchForm.cusId == 0 ? null : this.searchForm.cusId,
        platformId: this.searchForm.platformId == 0 ? null : this.searchForm.platformId
      }
      $http("get", "mobile/sms/info/listForSmsInfo", param).then(res => {
        this.tableData = res.data;
        this.pageTotal = res.count == null ? 0 : res.count;
        this.selfLoadingClose()
      });
    }
  },
  created() {
    this.dropDownForCus(),
        this.dropDownForPlatfrom(),
        this.page()
  },
  mounted() {

  },
  activated() {
    if (!!this.$refs['singleTable']) {
      this.$refs.singleTable.doLayout();
    }
  },
}
</script>
<!--css部分-->
<style lang="less">
.smsPlatform {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;
  position: relative;

  .formbox {
    padding-right: 20px;
    max-height: 611px;
    overflow-y: auto;

    .inline-two {
      display: flex;

      .el-form-item {
        &:nth-child(2) {
          margin-left: 40px;
        }
      }
    }
  }

  /*到期日期*/

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 255px;
  }

  .tree-box {
    height: 100%;
  }

  .tree-scroll {
    height: 592px;
    overflow: auto;
    overflow-x: hidden;
    border: 1px solid #ebeef5;
  }

  .el-dialog__body {
    padding-right: 20px;
  }
}

// 主题切换后权限树的样式变化
.theme2 {
  /deep/ .tree-scroll {
    border-color: #494949;
  }
}

</style>